import styled from '@emotion/styled'
import { WebLink } from '@news-mono/web-common'
import { breakpoint, calcRem, colors, fonts } from '../../../__styling'

interface StyledArticleBylineProps {
    hasBackground?: boolean
    isLiveBlog?: boolean
}

export const StyledArticleByline = styled('div')<StyledArticleBylineProps>(
    ({ hasBackground, isLiveBlog }) => ({
        fontSize: calcRem(12),
        textAlign: 'center',
        fontFamily: fonts.sevennews.sansSerif,
        display: 'flex',
        alignItems: 'center',
        whiteSpace: 'pre-wrap',
        color: colors.sevennews.bauhausBlack80,
        background: hasBackground ? colors.sevennews.neonSilver30 : undefined,
        paddingRight: isLiveBlog ? calcRem(8) : calcRem(20),
        borderRadius: calcRem(22),
        marginRight: isLiveBlog ? 0 : calcRem(10),
        [breakpoint('xxs')]: {
            paddingRight: isLiveBlog ? calcRem(16) : calcRem(20),
        },
    }),
)

export const StyledArticleBylineAuthor = styled('span')({})

const MAX_AUTHORS_FOR_SINGLE_LINE = 2

export const StyledArticleBylineAuthorLink = styled(WebLink)<{
    numAuthors?: number
}>(({ numAuthors = 2 }) => ({
    textDecoration: 'none',
    color: 'inherit',
    height: calcRem(numAuthors <= MAX_AUTHORS_FOR_SINGLE_LINE ? 30 : 16),
    display: 'flex',
    alignItems: 'center',
    '&:hover': {
        textDecoration: 'underline',
    },
    whiteSpace: 'nowrap',
}))

export const StyledArticleBylineAuthorDelimiter = styled('span')<{
    numAuthors?: number
}>(({ numAuthors = 2 }) => ({
    color: 'inherit',
    lineHeight: calcRem(numAuthors <= MAX_AUTHORS_FOR_SINGLE_LINE ? 30 : 16),
    display: 'inline-flex',
}))

interface StyledAuthorThumbnailProps {
    isLast: boolean
}

export const StyledAuthorThumbnail = styled('img')<StyledAuthorThumbnailProps>(
    ({ isLast }) => ({
        width: calcRem(30),
        height: calcRem(30),
        borderRadius: '50%',
        marginRight: isLast ? calcRem(12) : 0,
    }),
)
export const StyledTimeAndProfilesWrap = styled('div')(({}) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
}))
export const StyledAuthorProfilesWrap = styled('div')(({}) => ({
    display: 'flex',
    flexFlow: 'row wrap',
    alignItems: 'flex-start',
    minWidth: '220px',
}))
